// extracted by mini-css-extract-plugin
export default {"Display":"Display_Display__Vb9mS","DisplayBPM":"Display_DisplayBPM__k96U1","BPM":"Display_BPM__WsgzF","BpmIcons":"Display_BpmIcons__sEGu6","DisplayDrum":"Display_DisplayDrum__Vzsvj"};